const CheckCircleFill: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g id="Action/check-circle-fill">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47714 17.5228 1.99999 12 1.99999C6.47715 1.99999 2 6.47714 2 12C2 17.5228 6.47715 22 12 22ZM15.5833 8.26829L10.9998 13.8034L8.75537 11.5591C8.46247 11.2663 7.98759 11.2663 7.69471 11.5592C7.40183 11.8521 7.40184 12.327 7.69474 12.6198L10.4697 15.3947C10.7627 15.6876 11.2378 15.6875 11.5306 15.3944L16.6444 9.32845C16.9372 9.03542 16.937 8.56055 16.6439 8.26779C16.3509 7.97503 15.876 7.97526 15.5833 8.26829Z"
        fill="#268038"
      />
    </g>
  </svg>
);

export default CheckCircleFill;
